import { COLORS, Col, FlexView, Row } from '@cuemath/comps';
import React from 'react';
import styled from 'styled-components';
import { Text } from '@cuemath/web-comps';
import TimeSlot from '../time-slot';

const TimeSlotsWrapper = styled(Row)`
  border-bottom: 1px solid ${COLORS.BG_GHOST};
`;
const TimeWrapper = styled(Col)`
  width: 112px;
`;

const HourlyTimeslots = ({ date, timeWindows }) => {
  return (
    <FlexView>
      {Object.keys(timeWindows)?.map(time => (
        <TimeSlotsWrapper key={time} gap={8}>
          <TimeWrapper gutter={8}>
            <Text variant="h6">{time}</Text>
          </TimeWrapper>
          {timeWindows?.[time]?.map(
            ({ slotStartTime, slotEndTime, teachers, isHighlighted }) => (
              <Col key={slotStartTime} gutter={8}>
                <TimeSlot
                  slotStartTime={slotStartTime}
                  slotEndTime={slotEndTime}
                  teachers={teachers}
                  isHighlighted={isHighlighted}
                  date={date}
                />
              </Col>
            ),
          )}
        </TimeSlotsWrapper>
      ))}
    </FlexView>
  );
};

export default HourlyTimeslots;
